import React, { useEffect, useState } from "react";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';

export default function Notification(props) {
    const [notification, setNotification] = useState(null);

    useEffect(() => {
        if (props.erro)
            console.log("ERROR:", props.erro)

        setNotification(props.erro);
    }, [props.erro]);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setNotification(null);
        if (props.setNotification)
            props.setNotification(null);
    };

    return (
        <div>
            {
                notification &&
                <Snackbar
                        open={!!notification} autoHideDuration={6000} onClose={handleClose}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    >
                    <Alert icon={<CheckIcon fontSize="inherit" />} severity={notification?.severity ?? 'Some error happened during the process!'} >
                        {notification?.msg}
                    </Alert>
                </Snackbar>
            }
        </div>
    );
}